<template>
    <!-- type="dark" is not yet implemented in bootstrap-vue-next, we use data-bs-theme="dark" to fix it -->
    <b-navbar
        toggleable="lg"
        type="dark"
        class="navbar px-3"
        :container="false"
        data-bs-theme="dark"
    >
        <b-navbar-brand to="/">
            <img alt="Kasiopea" src="@/assets/logo.svg"/>
        </b-navbar-brand>
        <div class="d-lg-none">
            <LoginButton/>
            &nbsp;
            <b-navbar-toggle target="nav-collapse"/>
        </div>


        <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav class="nav-item-container">
                <b-nav pills>
                    <router-link v-for="page in menu" :key="page.path" v-slot="{ navigate }" :to="page.path" custom>
                        <BNavItem class="nav-item" :active="$route.path.startsWith(page.path)" @click="navigate">
                            {{ page.meta.title }}
                        </BNavItem>
                    </router-link>
                </b-nav>
            </b-navbar-nav>
        </b-collapse>

        <div class="d-none d-lg-flex">
            <LoginButton/>
            &nbsp;
            <b-navbar-toggle target="nav-collapse"/>
        </div>
    </b-navbar>
</template>

<script lang="ts">
import { GeneratedMenu } from '@/types';
import { PropType, defineComponent } from 'vue';

export default defineComponent({
    name: 'MainMenu',
    props: {
        menu: {
            type: Array as PropType<GeneratedMenu[]>,
            default() {
                return [];
            },
        },
    },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@use "@/styles/variables.scss";

/* Medium devices (tablets, 898px and up) */
@media (min-width: 898px) {
    .navbar {
        justify-content: center;
        align-items: end;
    }

    .navbar :deep(*) {
        flex-grow: 0;
    }
}

.navbar {
    background-color: variables.$purple_600;
}

.nav-item-container {
    list-style-type: none;
    padding: 0;
}

.navbar-nav {
    justify-content: space-evenly;
    flex-wrap: wrap;
    margin-right: var(--bs-navbar-brand-margin-end);
}

.navbar-expand-md:deep(.navbar-nav .nav-link) {
    padding: 8px 12px;
}

.navbar-nav .nav-item:deep(.nav-link) {
    color: variables.$purple_200;
    font-weight: bold;
    transition: all 0.3s ease 0s;
    border-width: 2px;
    border-style: solid;
    border-color: transparent;
}

.navbar-nav .nav-item:deep(.nav-link.active) {
    color: variables.$purple_200;
    background-color: variables.$purple_600;
    border-radius: 8px;
    border-color: variables.$purple_200;
}

/* Small devices (896px and below) */
@media (max-width: 896px) {
    .navbar-nav {
        flex-direction: row;
        flex-wrap: wrap;
        max-width: 400px;
        margin: 0px auto;
    }

    .nav-item {
        flex-basis: 50%;
    }

    .nav-item-container {
        margin: 10px auto;
    }

    .navbar {
        padding-bottom: 1rem;
    }
}
</style>
